import { useLocation, useNavigate, useParams } from "react-router-dom";
import httpClient from "../../HTTPService";
import { useEffect, useState } from "react";
import noimage from '../../assets/noimage.jpg'
import MemberConpopnent from "./membercomponent";
import moment from "moment";

function MemberTeam() {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search); // Parse query string
  const id = queryParams.get('id');
  // const userId = queryParams.get('userId');
  const userId = useParams(); // Get userId from URL parameters
  const [accouuntDetaila, setaccountDetails] = useState()
  const [accountDetails, setAccountDetails] = useState({})
  const [searchMembershipType, setSearchmemship_type] = useState(null)
  const [level, setlevel] = useState(null)
  const [uplineData, setUplineData] = useState([])
  const [depthListData, setdepthList] = useState([])
  const navigate = useNavigate()
  useEffect(() => {
    console.log(id, 'id view...')
    getMembersDetailsView()
    depthList()
    getUplineData()
  }, [id])
  const getMembersDetailsView = async () => {
    try {
      const result = await httpClient.post('/admin/members-view', { id: id }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      if (result.status === 200) {
        console.log(result?.data?.data, 'darta...')
        // console.log(result.data?.member_details, 'data members view')
        setaccountDetails(result.data?.data)
        setAccountDetails(result.data?.member_details)
        // setSubscriptionList(result.data?.subscriptions)
      }

    } catch (error) {
      //   toast.error(error.message)
    }
  }

  const depthList = async () => {
    try {
      const result = await httpClient.post('/admin/depth-list', { user_id: id }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      if (result.status === 200) {
        console.log("depth list", result.data?.data)
        // let data= Object.entries(result.data?.data)
        let _obj_data = Object.entries(result.data?.data).map(([key, value]) => ({
          id: Number(key),
          ...value
        }))
        setdepthList(_obj_data)


      }

    } catch (error) {
      //   toast.error(error.message)
    }
  }

  const getUplineData = async () => {
    try {
      const result = await httpClient.post('/admin/depth-upline-member-list', {

        user_id: id,

      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })

      if (result.status === 200) {
        let week_arr = []
        console.log(result.data.data, 'data..')
        // setTotalCount(result?.data.total_count)
        setUplineData(result?.data?.data)

        // setweeklyData(result?.data?.weekly_report_data)
      }

    } catch (error) {
      //   toast.error(error.message)
    }
  }

  return (
    <>
      <div
        className="header-back"
        onClick={() =>
          navigate("/member", {
            state: {
              backpagi: location?.state?.paginationState,
            },
          })
        }
      >
        <div></div>
        <div className="back-button">
          <i
            class="fa fa-arrow-left back-arrow-button"
            // className="back-arrow-button"
            aria-hidden="true"
          ></i>
        </div>
      </div>
      <div className="row">
        <div className="card col-md-5">

          <h5>Profile Details</h5>

          {/* <div className="acc-profile-image-section ">
                                
                                <p>Profile Image :</p>
                                
                                <div className="acc-details-image">
                                    <div className="image-container">
                                        <img
                                            className="image-acc-details"
                                            src={accouuntDetaila?.profile_photo_url !== null ?
        
                                                accouuntDetaila?.profile_photo_url : noImage
                                            }></img>
                                    </div>
        
                                    <div>
        
                                        <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                                    </div>
                                </div>
                            </div> */}


          <div className="account-details" style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}>
            <div>
              <p>Name : {accouuntDetaila?.name} </p>
              {/* <p className="ml-2"></p> */}
            </div>



            <div>

              <span className={accouuntDetaila?.active == 1 ? " active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
            </div>



          </div>
          {/* <div className="account-details">
                                <p>Email : </p>
                                <p className="ml-2"> {accouuntDetaila?.email}</p>
                            </div> */}
          <div className="account-details">
            <p>Phone : </p>
            <p className="ml-2">{accouuntDetaila?.phone}</p>
          </div>
          <div className="account-details">
            <p>Member Id : </p>
            <p className="ml-2">{accouuntDetaila?.user_referral_code}</p>
          </div>
          <div className="account-details">
            <p>Joining Date : </p>
            <p className="ml-2">{accouuntDetaila?.joing_date !== null ?
              moment(accouuntDetaila?.joing_date).format('DD-MM-YYYY') : null}</p>
          </div>
          <div className="account-details">
            <p>Refered By : </p>
            <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
              accouuntDetaila?.referral_code : null}</p>
          </div>
          <div className="account-details" style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}>
            <p>Depth Line : <span style={{ color: 'green' }}> {uplineData?.length} </span></p>

            <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">Check UP-line</button>

          </div>
          <div className="addres-account-details">
            <p>Address:
              {`${accouuntDetaila?.state !== null ? `${accouuntDetaila?.state?.name},` : ''}
                                 ${accouuntDetaila?.district !== null ? `${accouuntDetaila?.district?.district_name},` : ''} 
                                 ${accouuntDetaila?.city !== null ? `${accouuntDetaila?.city},` : ''}
                                 ${accouuntDetaila?.pin_code !== null ? `${accouuntDetaila?.pin_code}` : ''}`}
            </p>
          </div>
          <div className="account-details" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row'
          }}>
            <p>Position : </p>
            <button type="button"
              style={{
                backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red',
                border: 'none',
                fontSize: 12,
                color: 'white'
              }}
              data-toggle="modal" data-target=".bd-example-modal-lg">{accouuntDetaila?.position !== null ?
                accouuntDetaila?.position : null}</button>

            {/* <h6 className="ml-2 user-position" style={{
                                    backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red'
                                }}
        
                                >{accouuntDetaila?.position !== null ?
                                    accouuntDetaila?.position : null}</h6> */}
          </div>
          <div className="account-details">
            <p>Become Active On : {moment(accountDetails?.member_active_date).format('DD-MM-YYYY')}</p>
            {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                                     accouuntDetaila?.referral_code : null}</p> */}
          </div>
          <div className="account-details">
            <p>Last Open On :  {accountDetails?.last_login && moment(accountDetails?.last_login).format('DD-MM-YYYY')}  {accountDetails?.last_login && moment(accountDetails?.last_login).format('LT')}</p>

            {/* <p>Last Active On : {
                                             
                                             moment(accountDetails?.last_login).format('DD-MM-YYYY')}  {moment(accountDetails?.last_login).format('LT')
                                             
                                             }</p> */}
            {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                                                                   accouuntDetaila?.referral_code : null}</p> */}
          </div>

        </div>
        <div className="col-md-6 ml-5" style={{
          marginLeft: 10
        }}>
          <div className="row">
            <div className="col-md-12 ">
              <div className="team-heading " style={{
                backgroundColor: "#a84e42",
                paddingLeft: 5,
                paddingRight: 5

              }}>
                <p className="">Direct Line Total Members: {accountDetails?.total_depth_1_members}</p>
                <p>(Depth 1)</p>
                {/* <p className="mr-2">Total Commision : {accountDetails?.depth_1_total_commission}</p> */}
              </div>
              <div className="box-teammember row p-3 mt-0">
                <div className="box-team-acc col-md-5" style={{
                  cursor: 'pointer',
                  backgroundColor: '#9ab851'
                }}
                  onClick={() => {
                    setlevel(1)
                    setSearchmemship_type(3)
                  }}
                >
                  <div>Unpaid Member : {accountDetails?.total_depth_1_unpaid_members}</div>
                </div>
                <div className="box-team-acc col-md-5 ml-3" style={{
                  cursor: 'pointer',
                  backgroundColor: '#77cbd1'
                }} onClick={() => {
                  console.log('right box clicked...>>>>>>>>>>>')
                  setlevel(1)
                  setSearchmemship_type(4)
                }}>
                  <div>Paid Member : {accountDetails?.total_depth_1_paid_members}</div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-0 ">
              <div className="team-heading " style={{
                backgroundColor: "#a84e42",
                paddingLeft: 5,
                paddingRight: 5
              }}>
                <p className="ml-3">Level 2 -second line member : {accountDetails?.total_depth_2_members}</p>
                <p>(Depth 2)</p>
              </div>
              <div className="box-teammember row p-3 mt-2">
                <div className="box-team-acc col-md-5" style={{
                  cursor: 'pointer',
                  backgroundColor: '#925ebd'

                }} onClick={() => {
                  setlevel(2)
                  setSearchmemship_type(3)
                }}>
                  <div>Unpaid Member : {accountDetails?.total_depth_2_unpaid_members}</div>
                </div>
                <div className="box-team-acc col-md-5 ml-3" style={{
                  cursor: 'pointer',
                  backgroundColor: '#bd87ceff'
                }} onClick={() => {
                  setlevel(2)
                  setSearchmemship_type(4)
                }}>
                  <div>Paid Member : {accountDetails?.total_depth_2_paid_members}</div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-0">
              <div className="team-heading " style={{
                backgroundColor: "#a84e42",
                paddingLeft: 5,
                paddingRight: 5

              }}>
                <p className="ml-3"> All Depth Line Total Members : {accountDetails?.total_members}</p>
                {/* <p className="mr-2">Total Commision : {accountDetails?.depth_1_total_commission}</p> */}
              </div>

              <div className="box-teammember row p-3 mt-2">
                <div className="box-team-acc col-md-5" style={{
                  cursor: 'pointer',
                  backgroundColor: '#0d6efd'

                }} onClick={() => {
                  setlevel(null)
                  setSearchmemship_type(3)
                }}>
                  <div>Unpaid Member : {accountDetails?.total_unpaid_members}</div>
                </div>
                <div className="box-team-acc col-md-5 ml-3" style={{
                  cursor: 'pointer',
                  backgroundColor: '#5856d6',
                }} onClick={() => {
                  setlevel(null)
                  setSearchmemship_type(4)
                }}>
                  <div>Paid Member : {accountDetails?.total_paid_members}</div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-5 ">
              <div className="row">
                {
                  depthListData?.slice(2)?.map((item, i) => {
                    return (
                      <>
                        <div className="col-md-1" style={{
                          height: 30, width: 30,
                          backgroundColor: level == item?.depth ? 'burlywood' : '#5856d6',
                          margin: 5,
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                          color: '#FFFFFF',
                          cursor: 'pointer'
                        }}
                          onClick={() => {
                            setlevel(item?.depth)
                            setSearchmemship_type(null)

                          }}
                        >
                          D{item.depth}
                        </div>
                      </>
                    )
                  })

                }
              </div>

            </div>
          </div>
        </div>
        <div className="col-md-6 ml-5">
          <div className="row">
            {/* {Object.entries(accountDetails).map(([key, value]) => (
              <div className="col-md-12 " key={key}>
                <div className="team-heading row">
                  <p className="ml-3">Direct Members: {value.depth}</p>
                </div>

                <div className="box-teammember row p-3 mt-2">
                  <div className="box-team-acc col-md-5 ml-3" onClick={() => navigate(`/depth-members/${id}/${value.member_count}`)}>
                    <div>Total Member : {value.member_count}</div>
                  </div>
                </div>
              </div>
            ))} */}

            {/* <div className="col-md-12 mt-5 ">
                            <div className="team-heading row">
                                <p className="ml-3">Depth 2 Members : {accountDetails?.total_depth_2_members}</p>
                                <p className="mr-2">Total Commision : {accountDetails?.depth_2_total_commission}</p>
                            </div>
                            <div className="box-teammember row p-3 mt-2">
                                <div className="box-team-acc col-md-5">
                                    <div>Unpaid Member : {accountDetails?.total_depth_2_unpaid_members}</div>
                                </div>
                                <div className="box-team-acc col-md-5 ml-3">
                                    <div>Paid Member : {accountDetails?.total_depth_2_paid_members}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mt-5 ">
                            <div className="team-heading row">
                                <p className="ml-3">Total Members : {accountDetails?.total_members}</p>
                                <p className="mr-2">Total Commision : {accountDetails?.total_income}</p>
                            </div>
                            <div className="box-teammember row p-3 mt-2">
                                <div className="box-team-acc col-md-5">
                                    <div>Unpaid Member : {accountDetails?.total_unpaid_members}</div>
                                </div>
                                <div className="box-team-acc col-md-5 ml-3">
                                    <div>Paid Member : {accountDetails?.total_paid_members}</div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>


        {/* /// upline member list  */}
        <MemberConpopnent user_id={id} level={level} search_membership_type={searchMembershipType} />
      </div>
      <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content" style={{
            padding: 20
          }}>
            <div class="row">
              <h5>Up Line Members</h5>
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>SL NO</th>
                        <th> Member ID</th>
                        <th>Name</th>
                        {/* <th>Validity</th>
                <th >Description</th> */}
                        {/* <th>Discount</th>
                <th>Price</th> */}

                        <th>Mobile</th>
                        <th>Address</th>
                        <th>Joing Date</th>
                        <th>Depth Line</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        uplineData?.map((item, index) => {
                          return (
                            <>
                              <tr>
                                <td>{index + 1}</td>

                                <td>{item?.member_code}</td>
                                <td >
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>

                                    {item?.name}
                                    {item?.active == 1 ?
                                      <span className="ml-2 active_profile_table" style={{
                                        color: 'green'
                                      }}>Active</span>
                                      :
                                      <span className="ml-2 inactive_profile_table" style={{
                                        color: 'red'
                                      }}>Inactive</span>
                                    }
                                  </div>

                                </td>
                                <td>{item?.phone}</td>
                                <td>{item?.address !== null ? item?.address : '--'}</td>
                                <td>{moment(item?.joing_date).format('DD-MM-YYYY')}</td>
                                <td style={{
                                  textAlign: 'center',
                                  // dis
                                }}>{item?.level}</td>
                              </tr>
                            </>
                          )
                        })
                      }


                    </tbody>

                  </table>
                  <div className='nodata-found-div'>
                    {
                      uplineData?.length == 0 ?
                        <p>No Data Found</p>
                        //  <img 
                        //  className='table-image'
                        //  src={require('../../assets/OIP.png')}/>
                        : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default MemberTeam